export default __webpack_public_path__ + "pdf/Flyer.bd7e83d.pdf";